// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__OsYNt","title":"Info_title__1sSAd","selects":"Info_selects__2l9Eg","requiredAsterisk":"Info_requiredAsterisk__MG4Oo"};